import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgGlobe = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 32,
	height: 32,
	viewBox: "0 0 32 32",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M28.3337 16.0001C28.3337 9.18857 22.8118 3.66675 16.0003 3.66675C9.18881 3.66675 3.66699 9.18857 3.66699 16.0001C3.66699 22.8116 9.18881 28.3334 16.0003 28.3334C22.8118 28.3334 28.3337 22.8116 28.3337 16.0001ZM30.3337 16.0001C30.3337 23.9162 23.9164 30.3334 16.0003 30.3334C8.08424 30.3334 1.66699 23.9162 1.66699 16.0001C1.66699 8.084 8.08424 1.66675 16.0003 1.66675C23.9164 1.66675 30.3337 8.084 30.3337 16.0001Z",
			fill: "#3D3D3D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M29.3337 15C29.8859 15 30.3337 15.4477 30.3337 16C30.3337 16.5523 29.8859 17 29.3337 17H2.66699C2.11471 17 1.66699 16.5523 1.66699 16C1.66699 15.4477 2.11471 15 2.66699 15H29.3337Z",
			fill: "#3D3D3D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.9996 1.66675C16.2805 1.66675 16.5484 1.78489 16.7378 1.99227C20.2364 5.82238 22.2249 10.7929 22.3329 15.9792C22.3332 15.9931 22.3332 16.007 22.3329 16.0209C22.2249 21.2072 20.2364 26.1778 16.7378 30.0079C16.5484 30.2153 16.2805 30.3334 15.9996 30.3334C15.7536 30.3334 15.5176 30.2426 15.3355 30.0808L15.2613 30.0079C11.7628 26.1778 9.77428 21.2072 9.66623 16.0209C9.66594 16.007 9.66594 15.9931 9.66623 15.9792C9.77428 10.7929 11.7628 5.82238 15.2613 1.99227L15.3355 1.91935C15.5176 1.75753 15.7536 1.66675 15.9996 1.66675ZM15.9996 4.20451C13.2937 7.53938 11.7607 11.6856 11.6662 16.0001C11.7607 20.3142 13.2941 24.4596 15.9996 27.7944C18.705 24.4596 20.2371 20.3142 20.3316 16.0001C20.2371 11.6856 18.7054 7.53937 15.9996 4.20451Z",
			fill: "#3D3D3D"
		})
	]
});
export default SvgGlobe;
